// extracted by mini-css-extract-plugin
export default {"emojiIcon":"styles-module__emojiIcon--AXyd_","emojiContainer":"styles-module__emojiContainer--yBvrp","createMenu":"styles-module__createMenu--DlSRV"};